import {
  UserManager,
  WebStorageStateStore,
  type UserManagerSettings,
} from "oidc-client-ts";

import type { EnvConfig, EnvName } from "../config/envs";

const managers = new Map<EnvName, UserManager>();

function buildSettings(env: EnvConfig): UserManagerSettings {
  const origin = window.location.origin;
  return {
    authority: env.keycloakIssuer,
    client_id: env.keycloakClientId,
    redirect_uri: `${origin}/callback`,
    post_logout_redirect_uri: `${origin}/`,
    silent_redirect_uri: `${origin}/silent-renew.html`,
    response_type: "code",
    scope: "openid profile email",
    automaticSilentRenew: true,
    userStore: new WebStorageStateStore({
      store: window.localStorage,
      prefix: `saltpig-admin:oidc:${env.name}:`,
    }),
    stateStore: new WebStorageStateStore({
      store: window.localStorage,
      prefix: `saltpig-admin:oidc:${env.name}:state:`,
    }),
  };
}

/**
 * Returns a memoized UserManager keyed by env name. Token storage in
 * localStorage is namespaced per env, so signing in to dev does not leak
 * to staging/prod and vice versa — toggling envs preserves each session.
 */
export function getUserManager(env: EnvConfig): UserManager {
  const cached = managers.get(env.name);
  if (cached) return cached;
  const created = new UserManager(buildSettings(env));
  managers.set(env.name, created);
  return created;
}
